import get from 'lodash/get'
import { FieldErrors } from 'react-hook-form'

interface ErrorMessages {
  patternErrorMessage?: string
  requiredErrorMessage?: string
  validateErrorMessage?: string
}

export function getErrorMessage(
  name: string,
  errors: FieldErrors,
  errorMessages?: ErrorMessages,
) {
  const fieldError = get(errors, name)

  if (!fieldError)
    return undefined

  if (fieldError?.type === 'required')
    return errorMessages?.requiredErrorMessage // TODO set default message

  if (fieldError?.type === 'matchPattern')
    return errorMessages?.patternErrorMessage // TODO set default message

  if (fieldError?.type === 'validateAge')
    return errorMessages?.validateErrorMessage // TODO set default message
  return undefined
}
